import { map, merge, Observable } from 'rxjs';
import { Pub, Service, Sub } from '../../../services/service.abstract';
import { AIAssistanRes } from './aiAssistant.service';
import { IAlertMessage } from '../components/alertMessage.component';
import { storageHelper } from '../../../helpers/storage';

type Actions = 'user.message' | 'assistant.message' | 'alertMessage' | 'favorite' | 'loading';

const favorites = storageHelper.local.getItem('assistant.favorites');
if (!favorites) {
  storageHelper.local.setItem('assistant.favorites', []);
}

class PubImpl extends Pub<Actions> {
  message({ type, message }: Pick<IChatboxMessage, 'type' | 'message'>): void {
    if (type === 'user') {
      this.emit('user.message', message);
    }
    if (type === 'assistant') {
      this.emit('assistant.message', message);
    }
    if (type === 'alertMessage') {
      this.emit('alertMessage', message);
    }
  }
  loading(loading: boolean): void {
    this.emit('loading', loading);
  }
  favorite(favorite: IFavorite): void {
    this.emit('favorite', favorite);
  }
}
class SubImpl extends Sub<Actions> {
  private messages: IChatboxMessage[] = [];
  private favorites: IFavorite[] = storageHelper.local.getItem('assistant.favorites');
  message(): Observable<IChatboxMessage[]> {
    const userMessage$ = this.actionListener('user.message').pipe(
      map(({ params }) => {
        this.messages.push({ type: 'user', message: params });
        return this.messages;
      }),
    );
    const assistantMessage$ = this.actionListener('assistant.message').pipe(
      map(({ params }) => {
        this.messages.push({ type: 'assistant', message: params });
        return this.messages;
      }),
    );
    const alertMessage$ = this.actionListener('alertMessage').pipe(
      map(({ params }) => {
        this.messages.push({ type: 'alertMessage', message: params });
        return this.messages;
      }),
    );
    return merge(userMessage$, assistantMessage$, alertMessage$);
  }
  loading(): Observable<boolean> {
    return this.actionListener('loading').pipe(
      map(({ params }) => {
        return params;
      }),
    );
  }
  favorite(): Observable<IFavorite[]> {
    return this.actionListener('favorite').pipe(
      map(({ params }) => {
        if (params.action === 'add') {
          this.favorites.push(params);
          storageHelper.local.setItem('assistant.favorites', this.favorites);
        } else {
          this.favorites = this.favorites.filter((favorite) => favorite.message !== params.message);
          storageHelper.local.setItem('assistant.favorites', this.favorites);
        }
        return [...this.favorites];
      }),
    );
  }
}

class ChatboxService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const chatboxService = new ChatboxService();
export interface IChatboxMessage {
  type: 'user' | 'assistant' | 'alertMessage';
  message: string | AIAssistanRes | IAlertMessage;
}
export interface IFavorite {
  action: 'add' | 'remove';
  date: number;
  message: string;
}
